import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Box, Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';

import {
  clearMessage,
  selectMessage,
  selectSeverity,
} from '../store/authSlice';

import SettingsForm from '../components/forms/SettingsForm';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      padding: [theme.spacing(2)],
    },
    maxWidth: 700,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}));

export default function Home() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const message = useSelector(selectMessage);
  const severity = useSelector(selectSeverity);

  const handleClose = () => {
    dispatch(clearMessage());
  };

  return (
    <>
      <Grid item xs={12}>
        <Box className={classes.root}>
          <SettingsForm />
        </Box>
      </Grid>
      <Snackbar open={!!message} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={severity}>{message}</Alert>
      </Snackbar>
    </>
  );
}
